import type { Header } from "@tanstack/react-table";
import { cn } from "src/shadcn/lib/utils";

interface ResizeHandleProps<TData> {
  header: Header<TData, unknown>;
  onReset?: (columnId: string) => void;
}

export const ResizeHandle = <TData,>({
  header,
  onReset,
}: ResizeHandleProps<TData>) => {
  if (!header.column.getCanResize()) return null;

  return (
    <div
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      onDoubleClick={() => {
        header.column.resetSize();
        onReset?.(header.column.id);
      }}
      className={cn(
        "absolute top-0 end-0 h-full w-1 cursor-col-resize select-none touch-none",
        header.column.getIsResizing()
          ? "bg-primary"
          : "bg-border opacity-0 group-hover/head:opacity-100"
      )}
    />
  );
};
